import { type FOfferType } from '@/packages/JsonQuery';

import { type IConditionTypeOption } from '../types';

export function getConditionTypeList(_offerType: FOfferType): IConditionTypeOption[] {
  return [];
}
